<template>
  <div>

    <div class="search-box mt-10">
      <el-form :inline="true" :model="formData" class="user-form-inline" size="mini">
        
        <el-form-item label="任务类型">
          <el-select 
            v-model="formData.taskTypeList" 
            placeholder="请选择" 
            style="width:100px">
            <el-option label="全部" value=""></el-option>
            <el-option label="定时任务" value="TIMING"></el-option>
            <el-option label="临时任务" value="TEMPORARY"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务状态">
          <el-select 
            multiple
            collapse-tags
            clearable
            @clear="doReset"
            v-model="formData.statusList" 
            placeholder="请选择" 
            style="width:140px">
            <el-option label="等待中" value="WAITING"></el-option>
            <el-option label="排队中" value="QUEUE"></el-option>
            <el-option label="采集中" value="RUNNING"></el-option>
            <el-option label="已完成" value="COMPLETED"></el-option>
            <el-option label="失败" value="FAILED"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属用户">
          <el-select
            v-model="formData.userId"
            filterable
            remote
            clearable
            default-first-option
            placeholder="请输入选择"
            style="width:120px"
            no-data-text="找不到用户"
            @clear="doReset"
            :remote-method="doSearchUser"
            :loading="isUserLoading">
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="item.memo"
              :value="item.userId">
              <span style="float: left; margin-right:5px;"><Avatar size="small" :src="item.headImgUrl" fit="cover"></Avatar></span>
              <span style="float: left; margin-right:5px;">{{ item.fullName }}</span>
              <span style="float: right; margin-left:5px">{{ item.memo }}</span>
              <span style="float: right; margin-left:10px;"><Avatar size="small" :src="item.customHeadImgUrl" fit="cover"></Avatar></span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="doSearch" :loading="isSearching">查询</el-button>
        </el-form-item>
      </el-form>

    </div>
    <el-divider></el-divider>
    <TaskList :userId="formData.userId" :statusList="formData.statusList"  :taskTypeList="formData.taskTypeList" :updateTimer="formData.updateTimer" />

  </div>
</template>

<script>
// import Resources from '@/components/Resources';
import TaskList from '@/components/TaskList';
export default {
  name: 'Task-List',
  components: {
    TaskList
  },
  data(){
    
    return {
      formData:{
        statusList:[],
        taskTypeList:"",
        userId:null,
        updateTimer: (new Date()).getTime()
      },
      pagination:{
        size:10,
        page:1,
      },
      total:0,
      list:[],
      userList:[],
      isSearching:false,
      isUserLoading:false,
      modelType:'users',
      showFormEdit:false,
      isSyncIdLoading:0,
      currentData:{},
      logo:{
        XHS:require('@/assets/common/logo_xhs.png'),
        INS:require('@/assets/common/logo_ins.png'),
      }
    };
  },
  watch: {
    showFormEdit(newData){
      if(!newData){
        this.doSearch(false);
      }
    }
  },
  mounted () {
    this.doSearch();
    setTimeout(() => {
      console.log(132);
      this.doSearch();
    }, 6000);
  },
  methods: {

    doSearchUser(query){
      var userName = query.replace(/(^\s*)|(\s*$)/g, "");
      this.isUserLoading = true;

      this.request.get(`/api/v1/users?page=1&size=20&memo=${userName}`).then(res=>{
        this.isUserLoading = false;
        this.userList = [];
        if(!res || !res.results){return ;}
        // res.results.forEach(r => {
        //   if(typeof r.userId == 'number'){
        //     r.userId = r.userId.toString()
        //   }
        // });
        this.userList = res.results;
      });
    },
    stime: function(msd) {
      var time =msd
      if (null != time && "" != time) {
        if (time > 60 && time < 60 * 60) {
          time = parseInt(time / 60.0) + "分钟" + parseInt((parseFloat(time / 60.0) -
          parseInt(time / 60.0)) * 60) + "秒";
        }
        else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time = parseInt(time / 3600.0) + "小时" + parseInt((parseFloat(time / 3600.0) -
          parseInt(time / 3600.0)) * 60) + "分钟" +
          parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
          parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
        } else if (time >= 60 * 60 * 24) {
          time = parseInt(time / 3600.0/24) + "天" +parseInt((parseFloat(time / 3600.0/24)-
          parseInt(time / 3600.0/24))*24) + "小时" + parseInt((parseFloat(time / 3600.0) -
          parseInt(time / 3600.0)) * 60) + "分钟" +
          parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
          parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
        }
        else {
          time = parseInt(time) + "秒";
        }
      }
      return time;
    },
    doSyncById(item){
      
      this.isSyncIdLoading = item.postingId;
      var postingId = item.postingId;
      this.request.post(`/api/v1/postings/syncing/${postingId}`,{postingId}).then(res=>{
        this.isSyncIdLoading = 0;
        if(!res){return ;}
        this.$message.success("同步帖子成功!");
        this.doSearch(false);
      })
    },
    doEdit(index,row){
      console.log(row);
      this.currentData = this.$root.copy(row);
      this.showFormEdit = true;
    },
    doDelete(index,row){
      this.$confirm('此操作将永久删除该同步帖子, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.delete(`/api/v1/postings/${row.postingId}`).then(res=>{

          if(!res){return ;}
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.doSearch(false);
        })
        
      }).catch(() => {
                
      });
      
    },
    doSearchTag(query){
      var tagName = query.replace(/(^\s*)|(\s*$)/g, "");
      this.isUserLoading = true;

      this.request.get(`/api/v1/tags?page=1&size=5&tagName=${tagName}`).then(res=>{
        this.isUserLoading = false;
        this.userList = [];
        if(!res || !res.results){return ;}
        this.userList = res.results;
      });
    },

    getPosts(){
      console.log(arguments)
    },

    getList(url){
      this.isSearching = true;
      this.request.get(url).then(res=>{
        this.isSearching = false;
        this.list = [];
        this.total = 0;
        this.pagination.page = 1;
        if(!res){return ;}
        this.list = res.results || [];
        // this.list.map(d=>{
        //   d.resources.unshift({type:"IMAGE",url:d.thumbnailUrl});
        // })
        this.list.forEach(d=>{
          d.taskRate = (d.taskRate*100).toFixed(2);
        })
        this.total = res.total;
        // this.total = 646;
        this.pagination.page = res.page;

      });
    },
    doSearch(){
      this.formData.updateTimer = (new Date()).getTime();
      this.$set(this,'formData',this.formData);
      

      // var formData = {...this.pagination,...this.formData};
      // if(resetPage){formData.page = 1;}
      // var params = this.$root.object2urlparams(formData);


      // this.getList(`/api/v1/collectsTask/paging?${params}`);
      
    },
    doReset(){
      this.list = [];
      this.total = 0;
      this.pagination.page = 1;
      this.doSearch();
      // this.formData.collectType = 'INS';
    },
    doResetTagName(){
      if(this.$route.params.tagName){
        this.$router.push('/Home/Collect/User/List/');
      }
      this.doReset();
    },
  }
}
</script>
<style lang="less" scoped>
.logo{
  width:20px;
  vertical-align: middle;
}
</style>
<style lang="less">
.user-form-inline{
  .search-box{
    .el-select .el-input{
      width:160px;
    }
  }
}
</style>